<template>
  <hr class="margin-max-vertical">

  <div class="container margin-2xl-top">
    <card :auto-translate="false" title="playground" badge-text="testing area">
      <template #default>

        <form-input type="repeatableMedia"
                    label="select media repeatable"
                    v-model="test"
                    :fields="{
                      mediaUrl: {
                        name: 'mediaUrl',
                        valueField: 'url',
                        type: 'quickMedia',
                        label: 'media url',
                      },
                       alt: {
                        name: 'alt',
                        type: 'text',
                        label: 'media alt',
                      },
                       title: {
                        name: 'title',
                        type: 'text',
                        label: 'media title',
                      },
                    }"
                    :media-field-key="'mediaUrl'"
                    :media-data-key="'url'"
                    :max-image-width="500"
                    :max-image-height="500"
                    accept=""></form-input>
        <!--
               <form-input type="selectMedia"
                           label="select media"
                           v-model="test"
                           :max-image-width="50"
                           :max-image-height="50"
                           accept=""></form-input>

               <form-input type="mediaUrl"
                           v-model="test2"
                           label="media url input"></form-input>

               <create-review
                 v-if="showReviewForm"
                 @createReview:created="handleReviewAdded"
                 class="relative max-width-400" :product-id="20"></create-review>
       -->
        <!--
        <form-input
          v-model="tempData"
          type="currency"
          label="ecommerce.product.fields.price" />
        <block style="direction: ltr"> data: {{ tempData }} </block>
        <hr />
        <span>test: {{ translateNumber(2500, "currency", { from: "EUR" }) }}</span
        >
        <hr />
        <block style="direction: ltr">

        </block>
        -->
      </template>

      <template #footer> Footer</template>
    </card>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import useCarts from "@/client/extensions/composition/useCarts.js";
import PrimarySearch from "@/client/applications/justopp/components/widgets/PrimarySearch";
import CreateReview from "@/client/components/ecommerce/review/CreateReview";
import ProductRequester from "@/client/applications/justopp/components/widgets/ProductRequester.vue"
export default {
  name: "PlaygroundPage2",
  components: {
    PrimarySearch, CreateReview, ProductRequester
  },
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    let carts = useCarts(props);
    return { asyncOps, asyncOpsReady, asyncStatus, carts };
  },
  data: function () {
    return {
      test: [
        {
          "mediaUrl":"https://fileserver.saffron-technologies.com/api/files/1beb3bef-80b4-4b3c-9263-88c263dc621b/a521a60d-8f66-41a5-9f5d-40bf4ef8ff62.jpeg",
          "alt":'123',
          "title": 'abc',
        },
      ],
      test2: null,
      showReviewForm: true,
      tempData: "USD",
      product: {},
      asyncData: {
        product: {
          target: "ecommerce/product/1",
          data: {
            translate: true,
          },
        },
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  beforeUnmount() {},
  async created() {
    //console.log('before', this.$store.getters['currency/areExchangeRatesLoaded']);

    setTimeout(() => {
      //  this.$store.commit('currency/set', 'ILS')
    }, 2000);
    setTimeout(() => {
      //  this.$store.commit('currency/set', 'EUR')
    }, 4000);
    // TODO: get exchange rates into the client
    // use this to render a product price at it's currency, and current currency, SMOOTHLY
    //let result = await this.carts.createCart();
    //console.log(result, result.test);
    // let result = await this.carts.loadCartByUuid("64b0c771-6058-44a2-ae70-f0a08c601862");
    let cart = await this.carts.getCart();

    // let itemToAdd = {
    //   ProductId: 1,
    //  quantity: 1,
    // productConfig: {},
    //};
    //let addResult = await cart.addItem(itemToAdd);
    // await cart.empty();
    //console.log("here", cart.items.length);
    /*
    let updateData = {
      quantity: 10,
      //  productConfig: {"basicVariant": {"sku": "123-W"}}
    };
    try {
      await cart.updateItem(cart.items[0], updateData);
    } catch (e) {
      console.log(e);
    }
    // TODO: reactivity issue. Cart is a reference to an old object
    // the composition replaces it, and does not update it.
    console.log("items after", cart.items);
    //  let firstItem = cart.items[0];
    // let firstItemUuid = firstItem.uuid;
    //  console.log("item", firstItemUuid, cart.items[0]);
    //  await cart.removeItem(firstItem);
    */
  },
  methods: {
    handleReviewAdded(data) {
      console.log('review added event', data);
      this.showReviewForm = false;
    }
  },
};
</script>

<style scoped lang="scss"></style>
